var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6976 19.8454H8.04287C5.23111 19.8454 3.07403 18.8298 3.68675 14.7423L4.40018 9.20272C4.77788 7.16315 6.07884 6.38257 7.22033 6.38257H16.5537C17.712 6.38257 18.9374 7.2219 19.3738 9.20272L20.0873 14.7423C20.6076 18.3682 18.5093 19.8454 15.6976 19.8454Z",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8229 6.18116C15.8229 3.9932 14.0492 2.21952 11.8612 2.21952V2.21952C10.8076 2.21505 9.79566 2.63047 9.04908 3.3739C8.30249 4.11734 7.8828 5.12755 7.88281 6.18116H7.88281",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5803 10.3105H14.5383",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23459 10.3105H9.19263",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.93dac736f95d8820731dfa2b08f522d9.svg";
export { ForwardRef as ReactComponent };